import { createSlice } from "@reduxjs/toolkit";
import { FetchShopifyOrders } from "./shopifyOrdersAction";

interface ShopifyOrderState {
  shopifyOrder: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
}

const initialState: ShopifyOrderState = {
  shopifyOrder: [],
  loading: false,
  error: null,
  totalRecord:0
};

const shopifyOrderSlice = createSlice({
  name: 'shopifyOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchShopifyOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchShopifyOrders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.shopifyOrder = payload.data; // Store shopify Order list
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchShopifyOrders.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch shopify orders";
      });
  },
});

export const shopifyOrderReducer = shopifyOrderSlice.reducer;
